import React, { createContext, useState, useEffect } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { ParallaxProvider } from 'react-scroll-parallax';
import cls from 'classnames';
import * as firebase from 'firebase';
// Pages
import { Home } from './Pages/Home/Home';
import './App.scss';

export const $Global = createContext({} as Global.GlobalProps);
const initGlobal: Global.GlobalState = (() => {
  // dark mode
  let darkTheme = sessionStorage.getItem('darkTheme');
  if (!darkTheme) sessionStorage.setItem('darkTheme', JSON.stringify(false));
  return {
    darkTheme: JSON.parse(
      sessionStorage.getItem('darkTheme') as string
    ) as boolean
  };
})();
// initialization firebase
const initFirebase = firebase.initializeApp({
  apiKey: 'AIzaSyBlm0voO516pey8K5cNrz74Mzr8prEoEN8',
  authDomain: 'jimxiehome.firebaseapp.com',
  databaseURL: 'https://jimxiehome.firebaseio.com',
  projectId: 'jimxiehome',
  storageBucket: 'jimxiehome.appspot.com',
  messagingSenderId: '923298927722',
  appId: '1:923298927722:web:5e0ef948ea4a145c792613',
  measurementId: 'G-8NV2GGVX1J'
});
firebase.analytics();

const App: React.FC = () => {
  const [global, setGlobal] = useState(initGlobal);
  // update session
  useEffect(() => {
    const parseGlobal = JSON.parse(JSON.stringify(global));
    for (let o in parseGlobal) {
      // sessionStorage
      let _storage = JSON.parse(sessionStorage.getItem(o) as string);
      // global state
      let _global = parseGlobal[o];
      // 資料一樣不更新
      if (JSON.stringify(_storage) !== JSON.stringify(_global)) {
        console.log(`${o} need to update`);
        sessionStorage.setItem(o, JSON.stringify(parseGlobal[o]));
      }
    }
  }, [global]);

  return (
    <ParallaxProvider>
      <div className={cls('App', global.darkTheme ? 'darkTheme' : '')}>
        <$Global.Provider value={{ global, setGlobal }}>
          <Router>
            <Switch>
              <Route exact path="/" component={Home} />
            </Switch>
          </Router>
        </$Global.Provider>
      </div>
    </ParallaxProvider>
  );
};

export default App;
